import {
  CartRawModel,
  CartItemRawModel,
  CartItemExtrasRawModel,
} from '@/api/api-raw-models/cart-raw-model';
import {
  CartModel,
  CartItemModel,
  CartItemExtraModel,
} from '@/models/CartModel';

function mapCartItemExtras(e: CartItemExtrasRawModel): CartItemExtraModel {
  return {
    id: e.id,
    itemExtraListId: e.item_extra_list_id,
    itemExtraListItemId: e.item_extra_list_item_id,
    unitPrice: Number(e.unit_price).toFixed(2),
  };
}

function mapCartItem(e: CartItemRawModel): CartItemModel {
  return {
    id: e.id,
    extras: e.extras.map(mapCartItemExtras),
    menuId: e.menu_id,
    menuItemId: e.menu_item_id,
    menuItemSizeId: e.menu_item_size_id,
    note: e.note,
    quantity: e.quantity,
    unitPrice: Number(e.unit_price).toFixed(2),
  };
}

export const mapCart = (x: CartRawModel): CartModel => ({
  merchantName: x.cart.merchant_name,
  tip: Number(x.cart.tip).toFixed(2),
  tax: Number(x.cart.tax).toFixed(2),
  rewardValue: Number(x.cart.reward_value).toFixed(2),
  serviceFee: Number(x.cart.service_fee).toFixed(2),
  subTotal: Number(x.cart.sub_total).toFixed(2),
  totalPrice: Number(x.cart.total_price).toFixed(2),
  cartItems: x.cart.cart_items.map(mapCartItem),
});
